import { getCurrentUserProfileInfos } from "@api/core-api-utils";
import { faroCoreApiClient } from "@api/faro-core-api-client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { createSplashScreenPayload } from "@store/user/user-slice-helper";

/**
 * Fetches information of current logged in user
 * @throws {HttpUtils.FetchError} if the Core API client request fails
 */
export const fetchCurrentUser = createAsyncThunk("user/fetchCurrentUser", async ({
  companyId
}, {
  getState
}) => {
  const {
    app: {
      isDevModeEnabled
    }
  } = getState();
  return await getCurrentUserProfileInfos(companyId, isDevModeEnabled);
});

/**
 * Set the FueFlags (First User Experience). These flags determine which introduction (in the form of splash screen)
 * the user has seen so far. The provided payload will be set as FUE flags directly.
 * It will not be added to the existed FUE flags in backend
 * @throws {HttpUtils.FetchError} if the Core API client request fails
 */
export const setFueFlags = createAsyncThunk("user/setFueFlags", async (_, {
  getState
}) => {
  const {
    user: {
      splashScreens
    }
  } = getState();
  const fueFlags = createSplashScreenPayload(splashScreens);
  return await faroCoreApiClient.users.setUserFueFlags(fueFlags);
});

/**
 * Logs out the current user by calling the logout route. Does not take care of redirection afterwards
 * @throws {HttpUtils.FetchError} if the Core API client request fails
 */
export const logoutUser = createAsyncThunk("user/logoutUser", async () => {
  await faroCoreApiClient.users.logoutUser();
});

/**
 * Update information of current logged in user
 * @throws {Error} if the information to update profile is incomplete
 * @throws {HttpUtils.FetchError} if the Core API client request fails
 */
export const updateCurrentUserProfile = createAsyncThunk("user/updateCurrentUserProfile", async payload => {
  if (!payload) {
    throw new Error("The information to update profile is incomplete");
  }
  return await faroCoreApiClient.users.updateUserProfile(payload);
});

/**
 * Fetches information of current logged in user, extra details like login method, SSO provider
 * @throws {HttpUtils.FetchError} if the Core API client request fails
 */
export const getLoggedInUser = createAsyncThunk("user/getLoggedInUser", async () => {
  return await faroCoreApiClient.users.getLoggedInUser();
});